
import React, { useState, useEffect } from "react";

const VistaProcesos = () => {
  const PROCESOS = [
    { id: 1, nombre: "Generación alertas" },
    { id: 2, nombre: "Informe general completo" },
    { id: 3, nombre: "Actualización desde CMDB" },
    { id: 4, nombre: "Actualización findings masivo" },
    { id: 5, nombre: "Modelo masivo" },
    { id: 6, nombre: "Criticidad ACIs masiva" },
  ];

  const COMPANIAS = [
    { id: 0, nombre: "Global" },
    { id: 1, nombre: "Bancolombia" },
    { id: 2, nombre: "Nequi" },
    { id: 3, nombre: "BAM" },
    { id: 4, nombre: "Banco Agrícola" },
    { id: 5, nombre: "Banistmo" },
  ];

  const [selectedProceso, setSelectedProceso] = useState("");
  const [selectedCompania, setSelectedCompania] = useState("");
  const [ultimaEjecucion, setUltimaEjecucion] = useState(null);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;
  const fetchData = async (url, setter) => {
    try {
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (resp.ok) {
        const data = await resp.json();
        setter(data);
      } else {
        let detail = "";
        try {
          const errJson = await resp.json();
          detail = errJson?.detail || JSON.stringify(errJson);
        } catch {}
        throw new Error(`Error ${resp.status} ${detail}`);
      }
    } catch (err) {
      console.error("Error en fetchData:", err);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchUltimaEjecucion = async () => {
    if (selectedProceso) {
      fetchData(
        `${API_URL}administrador/procesos/${selectedProceso}/0/`,
        setUltimaEjecucion
      );
    }
  };

  const fetchLogs = async () => {
    fetchData(`${API_URL}administrador/procesos/0/0/`, setLogs);
  };

  const ejecutarProceso = async () => {
    setLoading(true);
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => {
        controller.abort();
        fetchLogs();
      }, 3000);

      const resp = await fetch(`${API_URL}administrador/procesos/${selectedProceso}/${selectedCompania}/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (resp.ok) {
        const data = await resp.json();
        console.log("Proceso ejecutado:", data);
      } else {
        let detail = "";
        try {
          const errJson = await resp.json();
          detail = errJson?.detail || JSON.stringify(errJson);
        } catch {}
        throw new Error(`Error ${resp.status} ${detail}`);
      }
    } catch (err) {
      if (err.name === "AbortError") {
        console.warn("La petición fue abortada (timeout).");
      } else {
        console.error("Error en ejecutarProceso:", err);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Seleccione proceso</h2>
      <select onChange={(e) => setSelectedProceso(e.target.value)}>
        <option value="">Seleccione Proceso</option>
        {PROCESOS.map((p) => (
          <option key={p.id} value={p.id}>
            {p.nombre}
          </option>
        ))}
      </select>

      <select onChange={(e) => setSelectedCompania(e.target.value)}>
        <option value="">Seleccione Compañía</option>
        {COMPANIAS.map((c) => (
          <option key={c.id} value={c.id}>
            {c.nombre}
          </option>
        ))}
      </select>

      <button onClick={fetchUltimaEjecucion}>Ver última ejecución</button>
      {ultimaEjecucion && <p>Última ejecución: {ultimaEjecucion}</p>}

      <button onClick={ejecutarProceso} disabled={loading}>
        {loading ? "Ejecutando..." : "Ejecutar"}
      </button>

      <h2>Últimos logs</h2>
      <button onClick={fetchLogs}>Actualizar</button>
      <table>
        <thead>
          <tr>
            <th>IDLogApp</th>
            <th>Fecha</th>
            <th>Descripcion</th>
            <th>Tipo Error</th>
            <th>Argumentos</th>
            <th>Instancia</th>
            <th>Traceback</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log) => (
            <tr key={log.id}>
              <td>{log.idlog_app}</td>
              <td>{log.fechaevento}</td>
              <td>{log.descripcion}</td>
              <td>{log.tipoerror}</td>
              <td>{log.argumentos}</td>
              <td>{log.instancia}</td>
              <td>{log.trace}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VistaProcesos;